import Modal from 'components/modal/modal';
import styled from '@emotion/styled';

const StyledModal = styled(Modal)`
    .modal__body {
        width: 100vw;
        max-width: 500px;
        background: #f1f1f1;
        padding: 20px;
        border-radius: 8px;
    }

    h4 {
        margin: 0 0 20px 0;
        font-size: 18px;
        color: #333;
    }

    .modal-content-body {
        margin-block: 20px;
    }

    .modal-content-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
`;

export default StyledModal;
